export default __webpack_public_path__ + "static/media/FlanneryCerbinBohach.81da6248.jpg";